import { render } from "./DocPageSidebarNavElement.vue?vue&type=template&id=344b6c3e"
import script from "./DocPageSidebarNavElement.vue?vue&type=script&lang=js"
export * from "./DocPageSidebarNavElement.vue?vue&type=script&lang=js"

import "./DocPageSidebarNavElement.vue?vue&type=style&index=0&id=344b6c3e&lang=css"

import exportComponent from "/codebuild/output/src2646400178/src/twilio-clone/docs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__